import React from 'react';
import { ImageFile } from '~/data/types/images';

const CarPromotionDoodleDiamond: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="30"
      fill="none"
      viewBox="0 0 36 30"
    >
      <path
        stroke="#FFE500"
        strokeLinecap="round"
        strokeWidth="3.772"
        d="M22.97 11.08c-1.696-.604-5.646-9.442-6.705-8.254s-2.228 8.863-3.29 8.935-11.422-1.92-10.81-1.027c.613.894 9.041 6.367 9.1 7.767s-2.839 9.084-1.777 9.012 7.688-7.003 9.12-7.029c1.433-.025 10.706 6.506 11.345 5.634s-4.415-7.582-4.044-8.615c.37-1.033 9.316-9.022 7.961-8.93s-9.204 3.112-10.9 2.507Z"
      ></path>
    </Component>
  );
};

export default CarPromotionDoodleDiamond;
